import { QUERY_GET_FACTORY_CATEGORIES_VH_UNLIMITED } from '../../fetch/constantQueries'
import { baseThunk } from '../../fetch/basicThunk';

export const getFactoryCategoriesSVUnlimited = baseThunk(`factoryCategoriesSVUnlimited/getCategoriesSVUnlimited`, QUERY_GET_FACTORY_CATEGORIES_VH_UNLIMITED, "GET")
